import React, { useContext, useEffect, useState } from "react";
import "./styles.css";
import { CSHeader, RippleButton, Switch } from "../../../Components/Atoms";
import { ChevronRightIcon } from "../../../Assets/images/svgs";
import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, useToast } from "@chakra-ui/react";
import CsModal from "../CsModal";
import { StoreContext } from "../../../Library/contexts";
import { getStickersByVid, unmapSticker, updateStickersSettings, updateUserSettings } from "../../../APIs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PATHS from "../../../Routes/paths";

const StickerSettings = () => {

  const [ showDeleteModal, setShowDeleteModal ] = useState(false);
  const [ userConfig, setUserConfig ] = useState({});
  const [ showStickerSelectionModal, setShowStickerSelectionModal ] = useState(false);
  const [ stickerToDel, setStickerToDel ] = useState(false);
  const [ searchParams ] = useSearchParams();
  const [ showSwitchLoader, setShowSwitchLoader ] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const Toast = useToast();

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");
  }, []);

  const [visibilityControls, setVisibilityControls] = useState([
    { idx: 1, key: "fn", setting: "Vehicle owner name", toggleState: 0 },
    { idx: 2, key: "ftyp", setting: "Vehicle fuel type", toggleState: 0 },
    { idx: 3, key: "emgCts", setting: "Emergency contacts", toggleState: 0 },
    { idx: 4, key: "bldGrp", setting: "Blood group", toggleState: 0 },
    { idx: 5, key: "img", setting: "Profile picture", toggleState: 0 },
  ]);

  const [otherControls, setOtherControls] = useState([
    { idx: 1, key: "pauseCalls", setting: "Stop receiving calls", description: "People who will scan the QR will not able to call you or your emergency contacts", toggleState: 0 },
    { idx: 2, key: "pauseScanning", setting: "Pause QR scanning", description: "People who will try to scan the QR will not be able to do it", toggleState: 0 },
    { idx: 3, setting: "Delete QR info", description: "This will delete all your information on this QR. You will be able to re-write again", delete: true },
  ]);

  const handleQrDeleteRequest = (stickerId) => {
    unmapSticker({ stickerId: stickerId }, (err) => {
      if (err) Toast({ id: "settings-error-toast", isClosable: true, description: "Unable to delete QR at the moment. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);
    });
  }

  const handleQrDelete = () => {
    handleQrDeleteRequest(stickerToDel.uniqueCode);
  }

  useEffect(() => {
    let selVid = searchParams.get("vid");
    if (!selVid) return navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);

    getStickersByVid(selVid, (err, data) => {
      if (err) {
        console.log(err);
        navigate(`/${PATHS.CONTACT_STICKER}${PATHS.PROFILE_PAGE}`);
      }
      else {
        if (!data || !data.stickers) return navigate(`/${PATHS.CONTACT_STICKER}${PATHS.LANDING_PAGE}`);

        const stickerData = data.profile; // Or data.profile if toggle data lives there
        const stickerSettings = data.stickers[0].settings; // Or data.profile if toggle data lives there
        const updatedControls = visibilityControls.map(control => {
          const settingValue = stickerData.settings[control.key]; // or data.profile[control.key]
          return {
            ...control,
            toggleState: settingValue ? 1 : 0, // or use !!settingValue
          };
        });
        const updatedStickerControls = otherControls.map(control => {
          const settingValue = stickerSettings[control.key];
          let obj = { ...control };
          if (!control.delete) obj["toggleState"] = settingValue ? 1 : 0;
          return obj;
        });

        setVisibilityControls(updatedControls);
        setOtherControls(updatedStickerControls);

        let config = { ...data.profile, stickerSettings: data.stickers[0], stickerCount: data.stickers.length, stickers: data.stickers };
        setUserConfig(config);
      }
    });
  }, [ navigate ]);

  const updateStickerProfile = (checked, control) => {
    setShowSwitchLoader({ ...control, profile: true });
    const payload = { contId: userConfig.idx, [control.key]: !!checked };
    updateUserSettings(payload, (err) => {
      setShowSwitchLoader({});
      if (err) Toast({ id: "settings-error-toast", isClosable: true, description: "Unable to update this setting. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else {
        const updated = visibilityControls.map(c =>
          c.idx === control.idx ? { ...c, toggleState: checked ? 1 : 0 } : c
        );
        setVisibilityControls(updated);
      }
    });
  }

  const updateStickerSettings = (checked, control) => {
    setShowSwitchLoader(control);
    const payload = { stickerIds: userConfig.stickers.map(sticker => sticker.uniqueCode), [control.key]: !!checked };
    updateStickersSettings(payload, (err) => {
      setShowSwitchLoader({});
      if (err) Toast({ id: "settings-error-toast", isClosable: true, description: "Unable to update this setting. Please try again later", position: "bottom", variant: "subtle", duration: 3000 });
      else {
        const updated = otherControls.map(c =>
          (c.idx === control.idx && !c.delete) ? { ...c, toggleState: checked ? 1 : 0 } : c
        );
        setOtherControls(updated);
        setShowSwitchLoader({});
      }
    });
  }

  const getStickerSelectionBody = () => {
    return (
      <div>
        {/* {alert(JSON.stringify(location.state.stickers))} */}
        {location.state.stickers ? <div>
          {location.state.stickers.map(sticker => (
            <div>
              <RippleButton className={"del-sticker-sel-btn"} onClick={() => {setStickerToDel(sticker); setShowStickerSelectionModal(false); setTimeout(() => setShowDeleteModal(true), 100)}}>
                {sticker.nm}
              </RippleButton>
            </div>
          ))}
        </div> : null}
      </div>
    )
  }

  const handleBackPress = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  const handleStickerSelectionToDel = (control) => {
    if (control.delete && location.state.stickers && location.state.stickers.length) {
      if (location.state.stickers && location.state.stickers.length > 1) setShowStickerSelectionModal(true);
      else {
        setShowDeleteModal(true);
        setStickerToDel(location.state.stickers[0]);
      }
    }
  }

  return (
    <div className="sticker-settings">
      <CSHeader headerText="Sticker Settings" onClick={handleBackPress}/>

      <div className="visibility-controls-container">
        <p className="visibility-controls-title">Control what others can see about you</p>
        { visibilityControls.map(control => (
          <div key={control.idx} className="visibility-control-box">
            <p className="setting-name">{control.setting}</p>
            {showSwitchLoader.profile && showSwitchLoader.idx === control.idx ? <Spinner className="toggle-setting-loader" /> : <Switch
              checked={control.toggleState === 1}
              onCheckedChange={(checked) => updateStickerProfile(checked, control)}
            />}
          </div>
        )) }
      </div>

      <div className="settings-control-separator"></div>

      <div className="other-controls-container">
        <p className="visibility-controls-title">Other Controls</p>
        { otherControls.map(control => (
          <div key={control.idx} onClick={() => handleStickerSelectionToDel(control)} className="visibility-control-box">
            <div className="settings-desc-container">
              <p className="setting-name">{control.setting}</p>
              <p className="setting-desc">{control.description}</p>
            </div>
            {control.delete ? <ChevronRightIcon className="delete-option-icon" /> : (
              !showSwitchLoader.profile && showSwitchLoader.idx === control.idx ? <Spinner className="toggle-setting-loader" /> : <Switch checked={control.toggleState === 1} onCheckedChange={(checked) => updateStickerSettings(checked, control)} />
            )}
          </div>
        )) }
      </div>

      {/* <Modal closeOnOverlayClick={true} isCentered={true} isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ModalOverlay />
        <ModalContent className="cs-delete-modal-content">
          <ModalHeader className="cs-delete-modal-header">Deleting QR info</ModalHeader>
          <ModalBody className="cs-delete-modal-body">
            This will delete all your information on this QR. Are you sure?
          </ModalBody>

          <ModalFooter className="cs-delete-modal-footer">
            <Button className="cs-delete-confirm-btn" variant="ghost" mr={2} _focus={{ boxShadow: "none" }} >I'm sure</Button>
            <Button className="cs-delete-cancel-btn" variant="ghost" pr={6} onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
      <CsModal
        openModal={showDeleteModal || showStickerSelectionModal}
        closeModal={() => {setShowDeleteModal(false); setShowStickerSelectionModal(false)}}
        headerText={showDeleteModal ? "Deleting QR info" : (showStickerSelectionModal ? "Please select QR to delete" : "")}
        bodyContent={showDeleteModal ? `This will delete all your information on "${stickerToDel.nm || "this"}" QR. Are you sure?` : (showStickerSelectionModal ? getStickerSelectionBody() : "")}
        confirmBtn={showDeleteModal ? "I'm sure" : null}
        onConfirm={showDeleteModal ? handleQrDelete : ""}
        cancelBtn={"Cancel"}
      />
    </div>
  )
}

export default StickerSettings
